const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (["3000", "3001"].includes(window.location.port)) return window.location.protocol + "//" + window.location.hostname + ":5000";
  return window.location.origin;
};

export const API_BASE_URL = getApiBaseUrl();
export const apiUrl = (path) => `${API_BASE_URL}${path}`;
export const mediaUrl = (path) => /^https?:\/\//i.test(path || '') ? path : apiUrl(path || '');

export const getErrorMessage = (error, fallback = 'Something went wrong.') => {
  const data = error?.response?.data;
  if (typeof data === 'string') {
    const match = data.match(/<pre>Error:\s*([^<]+)/i);
    if (match?.[1]) return match[1].trim();
    return fallback;
  }
  return data?.message || error?.message || fallback;
};
